<template>
  <div class="look-around">
    <h1 class="title">一带多看</h1>
    <a-tabs default-active-key="1" @change="handleCallback">
      <a-tab-pane key="1" tab="租客">
        <a-spin :spinning="spinning">
          <div>
            <div>
              <a-collapse accordion default-active-key="1" @change="getHousesList($event, 1)" :bordered="false">
                <!-- <template
                  v-hasPermi="['statistics:comprehensiveStatistics:inMoreStatisticsGuest']"
                  v-for="item in touristDataList"
                > -->
                <template v-for="item in touristDataList">
                  <a-collapse-panel :key="item.id">
                    <template slot="header">
                      <div>
                        <TenantViwe :touristData="item" :iscontractYype="true" />
                      </div>
                    </template>
                    <div class="houses-box">
                      <!-- 房源列表 -->
                      <a-spin :spinning="housesSpinning">
                        <div class="img-box" v-if="records.length === 0">
                          <no-data></no-data>
                        </div>
                        <houseViewList v-else :records="records" />
                        <!-- v-hasPermi="['statistics:comprehensiveStatistics:inMoreStatisticsHouse']" -->
                      </a-spin>
                    </div>
                  </a-collapse-panel>
                </template>
              </a-collapse>
            </div>
            <!-- 分页 -->
            <a-pagination
              class="ant-table-pagination"
              show-size-changer
              show-quick-jumper
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :showTotal="(total) => `共 ${total} 条`"
              @showSizeChange="onShowSizeChange"
              @change="changeSize"
            />
          </div>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane key="2" tab="售客" force-render>
        <a-spin :spinning="spinning">
          <div>
            <div>
              <a-collapse accordion default-active-key="1" @change="getHousesList($event, 2)" :bordered="false">
                <template
                  v-hasPermi="['statistics:comprehensiveStatistics:inMoreStatisticsGuest']"
                  v-for="item in touristDataList"
                >
                  <a-collapse-panel :key="item.id">
                    <template slot="header">
                      <div>
                        <TenantViwe :touristData="item" :iscontractYype="false" />
                      </div>
                    </template>
                    <div class="houses-box">
                      <!-- 房源列表 -->
                      <a-spin :spinning="housesSpinning">
                        <div class="img-box" v-if="records.length === 0">
                          <no-data></no-data>
                        </div>
                        <houseSellList v-else :records="records" />
                        <!-- v-hasPermi="['statistics:comprehensiveStatistics:inMoreStatisticsHouse']" -->
                      </a-spin>
                    </div>
                  </a-collapse-panel>
                </template>
              </a-collapse>
            </div>
            <!-- 分页 -->
            <a-pagination
              class="ant-table-pagination"
              show-size-changer
              show-quick-jumper
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :showTotal="(total) => `共 ${total} 条`"
              @showSizeChange="onShowSizeChange"
              @change="changeSize"
            />
          </div>
        </a-spin>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import TenantViwe from '@/components/Tenant/index.vue'
import {
  inMoreStatisticsGuest,
  inMoreStatisticsHouse,
  inMoreStatisticsGuestSale,
  inMoreStatisticsHouseSale
} from '@/api/system/achievement/list'
import houseViewList from '@/components/houseList/houseList.vue'
import houseSellList from '@/components/houseList/houseSellList.vue'
export default {
  name: 'AchievementLookAround',
  components: {
    TenantViwe,
    houseSellList,
    houseViewList
  },
  data () {
    return {
      text: 125,
      accordion: true,
      touristData: null,
      records: [],
      touristDataList: [],
      queryParam: {
        pageNum: 1,
        pageSize: this.$getters.pageSize
      },
      total: 0,
      spinning: false,
      housesSpinning: false
    }
  },
  methods: {
    // 选项卡租售切换
    handleCallback (val) {
      if (val === '2') {
        this.getTouristSourceSale()
      } else {
        this.getTouristSource()
      }
    },
    // 获取客源列表-租
    getTouristSource () {
      this.spinning = true
      inMoreStatisticsGuest(this.queryParam).then((res) => {
        this.spinning = false
        if (res.code === 200) {
          this.touristDataList = res.data.records
          this.total = res.data.total
        }
        console.log(res, 'res')
      })
    },
    // 获取客源列表-售
    getTouristSourceSale () {
      this.spinning = true
      inMoreStatisticsGuestSale(this.queryParam).then((res) => {
        this.spinning = false
        if (res.code === 200) {
          this.touristDataList = res.data.records
          this.total = res.data.total
        }
        console.log(res, 'res')
      })
    },
    // 客源分页
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getTouristSource()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getTouristSource()
    },

    // 获取房源源列表-租售
    getHousesList (id, val) {
      if (!id) return
      const parmars = {
        requirementId: id,
        pageSize: this.$getters.pageSize,
        pageNum: 1
      }
      if (val === 1) {
        this.housesSpinning = true
        inMoreStatisticsHouse(parmars).then((res) => {
          this.housesSpinning = false
          if (res.code === 200) {
            this.records = res.data.records
            // console.log(this.records, 'this.records')
          }
        })
      } else if (val === 2) {
        this.housesSpinning = true
        inMoreStatisticsHouseSale(parmars).then((res) => {
          this.housesSpinning = false
          if (res.code === 200) {
            this.records = res.data.records
            // console.log(this.records, 'this.records')
          }
        })
      }
    }
  },
  created () {
    this.getTouristSource()
  }
}
</script>
<style lang="less" scoped>
.look-around {
  height: 100%;
  background-color: #fff;
  width: 100%;
  padding: 20px;
  border-radius: 15px;
  padding-bottom: 60px;
  .title {
    font-size: 20px;
    font-weight: 700;
  }
  .ant-collapse {
    background-color: #fff;
  }
  /deep/.number {
    display: none;
  }
  .houses-box {
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 15px;
  }
  .img-box {
    text-align: center;
    img {
      width: 80px;
      height: 80px;
    }
  }
}
.fix_top .results_wrapper  {
  width:calc( 100% - 173px );
  position:fixed;
  top:0px;
  left:173px;
  z-index:9999;
  padding-top:10px;
  background: #fff;
}
</style>
